import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/react';
import type { ReportData } from '@/lib/types';
import { ReportHeader } from './ReportHeader';
import { ResumenTab } from './ResumenTab';
import { IntakeTab } from './IntakeTab';
import { BiomarkersTab } from './BiomarkersTab';
import { ClassifiersTab } from './ClassifiersTab';
import { NarrativeTab } from './NarrativeTab';

interface ReportShellProps {
  report: ReportData;
}

const tabClass = ({ selected }: { selected: boolean }) =>
  [
    'font-inherit text-[12.5px] px-4 py-2 cursor-pointer outline-none transition-colors rounded-md',
    selected
      ? 'bg-primary text-surface font-semibold'
      : 'bg-transparent text-tertiary font-medium hover:text-primary hover:bg-soft',
  ].join(' ');

export function ReportShell({ report }: ReportShellProps) {
  return (
    <div className="flex flex-col gap-3.5">
      <ReportHeader report={report} />

      <TabGroup>
        <TabList className="glass-panel flex gap-1 p-1.5 self-start max-[760px]:self-stretch max-[760px]:overflow-x-auto">
          <Tab className={tabClass}>Resumen</Tab>
          <Tab className={tabClass}>Contexto clínico</Tab>
          <Tab className={tabClass}>Biomarcadores</Tab>
          <Tab className={tabClass}>Clasificadores</Tab>
          <Tab className={tabClass}>Reporte</Tab>
        </TabList>

        <TabPanels className="mt-3">
          <TabPanel className="outline-none appear">
            <ResumenTab report={report} />
          </TabPanel>
          <TabPanel className="outline-none appear">
            <IntakeTab report={report} intake={report.intake} />
          </TabPanel>
          <TabPanel className="outline-none appear">
            <BiomarkersTab biomarkers={report.biomarkers} />
          </TabPanel>
          <TabPanel className="outline-none appear">
            <ClassifiersTab classifiers={report.classifiers} />
          </TabPanel>
          <TabPanel className="outline-none appear">
            <NarrativeTab narrative={report.narrative} classifiers={report.classifiers} />
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </div>
  );
}
